import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/AuthContext';
import Notificacao from '../Notificacao/Notificacao';
import './Header.css'

function Header() {

  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="header">
        <div className="container-lateral-header">
          <Notificacao />

          <div className="usuario-logado-container">
            <div className="info-usuario-logado">
              <h3>{user.nome}</h3>
              <p>{t("descricao-" +user.perfilUsuario.idPerfilUsuario)}</p>
            </div>

            {/* <div className="img-usuario-logado">
              <img src={logoImage} alt="Logo do usuário logado" />
            </div> */}
          </div>
        </div>
    </div>
  )
}

export default Header